<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    document.title = '一诺教育'
  }
}
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
